module.exports = __webpack_public_path__ + "static/img/ic_img_1.ed709d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/ic_img_1.png
// module id = Kspn
// module chunks = 22